import { render } from "./GotchiPage.vue?vue&type=template&id=6c829156&scoped=true"
import script from "./GotchiPage.vue?vue&type=script&lang=js"
export * from "./GotchiPage.vue?vue&type=script&lang=js"

import "./GotchiPage.vue?vue&type=style&index=0&id=6c829156&scoped=true&lang=css"

import exportComponent from "/media/riven/projects/aavegotchi/waardrobe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c829156"]])

export default __exports__